// extracted by mini-css-extract-plugin
export var drawerPaper = "_21-0";
export var itemImage = "_21-1";